/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ChameleonQueueStatus {
  PENDING_REVIEW = 'pending_review',
  CLEARED = 'cleared',
  CONFIRMED_FRAUD = 'confirmed_fraud',
}
